// @flow
import { get } from "lodash";
import mediatorChannels from "@tvg/mediator";
import pushToDataLayer from "../gtmUtils";

export default () => {
  mediatorChannels.base.subscribe(
    "CROSS_PRODUCT_CLICK",
    (data: {
      payload: { module: string, destinationUrl: string, eventLabel: string }
    }) => {
      pushToDataLayer({
        event: "navigation",
        gaEventCategory: "Navigation",
        gaEventAction: "Navigation Link Clicked",
        gaEventLabel: get(data, "payload.eventLabel", ""),
        module: get(data, "payload.module", ""),
        destinationUrl: get(data, "payload.destinationUrl", ""),
        tag: undefined,
        microApp: undefined
      });
    }
  );
};
